// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-button {
  height: 34px;
  width: calc(100% - 36px);
  padding: 18px;
  cursor: pointer;
}

.settings-button img {
  height: 36px;
  width: 36px;
  border-radius: 50%;
  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1);
  object-fit: cover;
}

.settings-button-placeholder {
  height: 36px;
  width: 36px;
  border-radius: 50%;
  background-color: #eee;
}

.settings-button-label {
  display: block;
  position: absolute;
  top: 20px;
  left: 75px;
  right: 8px;
  white-space: nowrap;
  font-size: 12px;
  line-height: 20px;
  color: rgb(255, 255, 255);
  font-family: Roboto, arial, sans-serif;
  opacity: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
}

.settings-button-organization {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.3);
  text-overflow: ellipsis;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/Menu/SettingsButton.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0DAA0D;EAC1D,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".settings-button {\n  height: 34px;\n  width: calc(100% - 36px);\n  padding: 18px;\n  cursor: pointer;\n}\n\n.settings-button img {\n  height: 36px;\n  width: 36px;\n  border-radius: 50%;\n  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  object-fit: cover;\n}\n\n.settings-button-placeholder {\n  height: 36px;\n  width: 36px;\n  border-radius: 50%;\n  background-color: #eee;\n}\n\n.settings-button-label {\n  display: block;\n  position: absolute;\n  top: 20px;\n  left: 75px;\n  right: 8px;\n  white-space: nowrap;\n  font-size: 12px;\n  line-height: 20px;\n  color: rgb(255, 255, 255);\n  font-family: Roboto, arial, sans-serif;\n  opacity: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.settings-button-organization {\n  display: block;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.3);\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
